import { apiCrm } from '../../../../http';

class CustomFieldsService {
  getCustomFields(recordTypeId) {
    return apiCrm.get(`custom-field/PROTOCOL/${recordTypeId}`);
  }
}

export default new CustomFieldsService();
